var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstSlideImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 201,
    viewBox: "0 0 445 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1754_32280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.213 14.7118L22.1526 60.9347C17.4888 63.6273 15.6219 69.3689 18.2023 73.8383L80.8051 182.27C83.3855 186.739 89.2914 187.993 93.9551 185.3L174.016 139.077C178.679 136.385 180.546 130.643 177.966 126.174L115.363 17.7425C112.783 13.2731 106.877 12.0192 102.213 14.7118Z",
    fill: "#7A88C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.931 20.0547L26.9227 63.3606C22.4533 65.941 21.64 70.8152 23.9961 74.8959L55.6341 129.695L172.284 125.307L113.608 23.6765C111.252 19.5957 106.4 17.4743 101.931 20.0547Z",
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4819 107.849C98.4336 99.7938 103.214 81.9538 95.1588 68.0021C87.1037 54.0504 69.2638 49.2702 55.3121 57.3253C41.3604 65.3803 36.5802 83.2202 44.6352 97.1719C52.6902 111.124 70.5302 115.904 84.4819 107.849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.95 124.665L82.0073 177.17L54.8569 130.145C101.494 103.219 157.243 97.4597 172.95 124.665Z",
    fill: "#7A88C0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1754_32280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.325 28.2109H173.879C168.494 28.2109 164.006 32.2498 164.006 37.4106V162.616C164.006 167.777 168.494 171.816 173.879 171.816H266.325C271.71 171.816 276.198 167.777 276.198 162.616V37.4106C276.198 32.2498 271.71 28.2109 266.325 28.2109Z",
    fill: "#7A88C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.408 32.7031H176.797C171.636 32.7031 168.494 36.5176 168.494 41.2297V104.506L271.711 159.031V41.6784C271.711 36.9664 268.569 32.7031 263.408 32.7031Z",
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.395 100.011C220.505 100.011 233.565 86.9517 233.565 70.8417C233.565 54.7316 220.505 41.6719 204.395 41.6719C188.285 41.6719 175.226 54.7316 175.226 70.8417C175.226 86.9517 188.285 100.011 204.395 100.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.608 158.797H167.597V104.496C221.449 104.496 272.608 127.383 272.608 158.797Z",
    fill: "#7A88C0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1754_32280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.086 67.6876L347.359 14.6628C342.947 11.574 336.955 12.3085 333.995 16.536L262.18 119.098C259.219 123.326 260.579 129.208 264.99 132.297L340.717 185.322C345.129 188.411 351.121 187.676 354.081 183.449L425.897 80.8864C428.857 76.6589 427.497 70.7764 423.086 67.6876Z",
    fill: "#7A88C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.122 69.6826L347.174 20.0041C342.947 17.044 338.185 18.3669 335.483 22.2267L299.189 74.0594L352.464 177.926L419.775 81.7967C422.478 77.9368 422.35 72.6428 418.122 69.6826Z",
    fill: "#374DA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.172 90.9849C344.369 100.225 362.557 97.0181 371.798 83.8216C381.038 70.625 377.831 52.4363 364.634 43.196C351.438 33.9556 333.249 37.1628 324.009 50.3593C314.768 63.5559 317.975 81.7446 331.172 90.9849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.328 178.263L267.308 118.031L298.454 73.5508C342.567 104.439 371.347 152.531 353.328 178.263Z",
    fill: "#7A88C0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1754_32280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.605,
    height: 143.605,
    fill: "white",
    transform: "translate(0 73.7188) rotate(-30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1754_32280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.605,
    height: 143.605,
    fill: "white",
    transform: "translate(148.3 28.1992)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1754_32280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 143.605,
    height: 143.605,
    fill: "white",
    transform: "translate(326.405) rotate(35)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstSlideImg);
export default __webpack_public_path__ + "static/media/firstSlideImg.6328d1507d0762f791dd470d5a53db60.svg";
export { ForwardRef as ReactComponent };